import * as React from "react";
import {IconProps} from "@components/Icons/IconTypes";

export const CalendarIcon = React.forwardRef<SVGSVGElement, IconProps>(
    ({size = 16, title, ...props}, ref) => {
        return (
            <svg
                ref={ref}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 16 16"
                width={size}
                height={size}
                fill="none"
                role="img"
                aria-hidden={title ? undefined : true}
                {...props}
            >
                {title && <title>{title}</title>}
                <path
                    fill="currentColor"
                    d="M1.5 11.5142V5.4817c0-1.1059.34-2.0237 1.0117-2.6621.5895-.5604 1.385-.859 2.2989-.9212v-.5652a.5.5 0 1 1 1 0v.5528h4.3854v-.5527a.5.5 0 1 1 1 0v.565c.9159.0622 1.7121.3608 2.3007.922.6702.6389 1.0064 1.5566 1.0033 2.6614v6.0833c0 1.105-.338 2.0239-1.0085 2.6641-.667.6369-1.6.9375-2.6725.9375H5.1803c-1.0716-.0001-2.0047-.3068-2.6718-.9531-.6697-.6491-1.0085-1.58-1.0085-2.6993Zm3.545-.5501c.276.0001.5.2239.5.5a.5002.5002 0 0 1-.5.5h-.0066a.5002.5002 0 0 1-.5-.5c0-.2761.224-.4999.5-.5h.0065Zm2.9641 0 .0514.0026a.5.5 0 0 1 0 .9948l-.0514.0026h-.0058a.5.5 0 0 1 0-1h.0058Zm2.9583 0 .0515.0026a.5.5 0 0 1 .4485.4974.5.5 0 0 1-.4485.4974l-.0515.0026h-.0058a.5.5 0 0 1 0-1h.0058ZM5.0449 8.373l.0508.0026a.5002.5002 0 0 1 .4492.4974c0 .259-.197.4718-.4492.4974l-.0508.0026h-.0065c-.276-.0001-.5-.224-.5-.5s.224-.5.5-.5h.0065Zm2.9642 0a.5.5 0 0 1 0 1h-.0058a.5.5 0 1 1 0-1h.0058Zm2.9583 0a.5.5 0 1 1 0 1h-.0058a.5.5 0 1 1 0-1h.0058Zm-.7714-4.8457V2.886H5.8106v.6413a.5004.5004 0 0 1-.5.5c-.2761 0-.5-.224-.5-.5v-.6257c-.7039.0594-1.2394.2903-1.61.6426-.4293.408-.7006 1.0386-.7006 1.9375v.2877h11v-.2897c.0027-.8991-.2661-1.5289-.6934-1.9362-.3691-.3518-.9044-.5826-1.6106-.6419v.6257a.5.5 0 0 1-1 0ZM2.5 11.5142c0 .917.2732 1.5632.7044 1.9812.4337.4201 1.0905.6711 1.976.6712h5.6386c.8915 0 1.5495-.2481 1.9818-.6608.4287-.4094.6992-1.0412.6992-1.9408V6.7695h-11v4.7447Z"
                />
            </svg>
        );
    }
);

CalendarIcon.displayName = "CalendarIcon";
